import { useEffect } from 'react';

import {
  isSubstepCompleted,
  resolveContinueAction
} from 'components/shared/OnboardingWizard/lib/resolveContinueAction';

export const useContactInfoEffects = ({
  formik,
  practice,
  setHeaderButtonProps,
  addFooterActions,
  orchestratorData,
  orchestratorLoading,
  mutateTwilioNumber,
  setTwilioError,
  onNext
}) => {
  useEffect(() => {
    setHeaderButtonProps(null);
    addFooterActions([
      {
        text: 'Continue',
        onClick: resolveContinueAction({
          isDirty: formik.dirty,
          isCompleted: isSubstepCompleted(orchestratorData),
          hasExistingData: formik.isValid,
          onSave: () => formik.submitForm(),
          onConfirm: () => formik.submitForm(),
          onNext
        }),
        isDisabled: orchestratorLoading || (!formik.isValid && formik.dirty)
      }
    ]);
  }, [formik.isValid, formik.dirty, orchestratorData?.handlerStatus, orchestratorLoading, onNext]);

  useEffect(() => {
    if (practice?.id && !practice?.twilio_phone) {
      const hasPracticeAddress = Boolean(practice?.practiceAddress?.address_ln_1);

      if (!hasPracticeAddress) {
        setTwilioError('Add your practice address to generate a patient communication number');
        return;
      }

      setTwilioError(null);
      mutateTwilioNumber();
    }
  }, [practice?.id, practice?.twilio_phone, practice?.practiceAddress?.address_ln_1]);
};
